import { Button } from 'antd';
import FormSelect from 'components/form/FormSelect';
import { useRestContext } from 'components/form/RestInputContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
// import { getDataDetail } from 'utils/tools';

const TransferOrderSelect = ({
  openSelectionModal,
  onClearSelectedRow,
  onClearFormValues,
}) => {
  const { t } = useTranslation();
  const { form } = useRestContext();

  const onSearchVariant = () => {
    openSelectionModal(form.getFieldValue('orderId'));
  };

  return (
    <div className="d-flex align-items-end w-full">
      <div className="flex-1 select-product">
        <FormSelect
          name="orderId"
          reference={{
            labelProp: 'orderNumber',
            model: 'orders',
            searchKey: 'orderNumber',
            initFilters: {
              join: ['payments', 'customer'],
              rawQuery: {
                $or: [
                  {
                    statusOms: {
                      $eq: 'PENDING_PROCESSING',
                    },
                  },
                  {
                    $and: [
                      {
                        orderType: {
                          $eq: 'TAB_TRY_BUY',
                        },
                      },
                      {
                        statusOms: {
                          $eq: 'CONFIRMED',
                        },
                      },
                    ],
                  },
                ],
              },
            },
            operator: 'contL',
            allowClear: true,
            // labelFormat: (e) =>
            //   `${e?.sku} - ${getDataDetail(e, 'detail', 'name', null)?.name}`,
          }}
          placeholder={t('transferOrders.searchOrder.placeholder')}
          extraOnChage={() => {
            form.setFieldValue('variantsApplied', []);
            form.setFieldValue('orderSelected', []);
            onClearSelectedRow();
            onClearFormValues();
          }}
        />
      </div>

      <Button className="ml-5 mb-5" type="primary" onClick={onSearchVariant}>
        {t('button.searchVariant')}
      </Button>
    </div>
  );
};

export default TransferOrderSelect;
